{
  "header": {
    "title": "Configuración",
    "description": "Administra tus preferencias, notificaciones y configuraciones de acceso para personalizar tu experiencia en Chirpee"
  },
  "tabs": {
    "workplace": {
      "title": "Lugar de trabajo",
      "logo": "Logo del lugar de trabajo",
      "changeLogo": "Cambiar logo",
      "logoEmptyState": "Aún no hay logo",
      "logoValidation": {
        "invalidFormat": "Elige una imagen PNG, JPEG, GIF o WebP.",
        "fileTooLarge": "La imagen debe pesar como máximo 5 MB.",
        "dimensionsTooLarge": "La imagen debe medir como máximo 4096 × 4096 píxeles.",
        "loadFailed": "No se pudo leer esta imagen. Prueba con otro archivo."
      },
      "logoUploadErrorFallback": "No se pudo subir el logo. Inténtalo de nuevo.",
      "maxSize": "Máx. 5 MB · máx. 4096 × 4096 px",
      "format": "PNG, JPEG, GIF o WebP",
      "worplaceNameInput": {
        "label": "Nombre del lugar de trabajo",
        "placeholder": "Nombre del lugar de trabajo"
      },
      "companyIndustryInput": {
        "label": "Industria de la empresa",
        "placeholder": "Industria de la empresa",
        "industries": {
          "technology": "Tecnología",
          "professionalServices": "Servicios profesionales",
          "financialServices": "Servicios financieros",
          "consulting": "Consultoría",
          "softwareDevelopment": "Desarrollo de software",
          "digitalMarketing": "Marketing digital",
          "mediaAndCommunications": "Medios y comunicaciones",
          "eCommerce": "Comercio electrónico",
          "healthTech": "Tecnología en salud"
        }
      },
      "languguages": {
        "title": "Idiomas compatibles",
        "helpText": "Texto de ayuda"
      },
      "applyButton": "Aplicar cambios"
    },
    "userManagement": {
      "title": "Gestión de usuarios",
      "userInput": {
        "placeholder": "Buscar usuarios"
      },
      "roleDropdown": {
        "triggerLabel": "Rol",
        "options": {
          "admin": "Administrador",
          "people_experience": "Experiencia de personas",
          "user": "Usuario"
        }
      }
    },
    "integrations": {
      "title": "Integraciones",
      "options": {
        "hris": { "label": "HRIS" },
        "sso": { "label": "Inicio de sesión único (SSO)" },
        "messagingConnected": { "label": "Herramienta de comunicación" }
      }
    },
    "billing": {
      "title": "Facturación",
      "planSection": {
        "title": "Tu plan",
        "status": {
          "active": "Activo"
        },
        "usersCount": {
          "title": "Usuarios mensuales"
        },
        "amount": {
          "title": "Monto de renovación",
          "cost": "por usuario"
        },
        "charge": {
          "title": "Próximo cargo"
        },
        "cycle": {
          "title": "Ciclo de facturación"
        }
      },
      "invoiceInformationSection": {
        "title": "Información de facturación",
        "name": "Nombre de la empresa",
        "email": "Correo de facturación",
        "address": "Dirección de la empresa",
        "taxId": "ID fiscal",
        "paymentMethod": "Método de pago",
        "paymentDate": "Fecha del último pago",
        "editButton": "Editar",
        "portalError": "No se pudo abrir el portal de facturación. Inténtalo de nuevo."
      },
      "invoiceHistorySection": {
        "title": "Historial de facturas",
        "viewButton": "Ver",
        "downloadButton": "Descargar",
        "emptyState": {
          "title": "Aún no hay facturas",
          "description": "Las facturas aparecerán aquí después de tu primer pago exitoso."
        }
      },
      "errorState": {
        "title": "No se pudieron cargar los datos de facturación",
        "description": "Actualiza la página e inténtalo de nuevo."
      }
    },
    "logs": {
      "title": "Registros de auditoría",
      "table": {
        "title": "Actividad reciente",
        "acitivityDropdown": {
          "triggerLabel": "Todas las actividades"
        },
        "usersDropdown": {
          "triggerLabel": "Todos los usuarios"
        },
        "exportButton": "Exportar registros"
      }
    }
  }
}
